var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Print"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0125 8.13194H4.9875C3.68025 8.13194 2.625 9.23931 2.625 10.6111V15.5694H5.775V18.875H15.225V15.5694H18.375V10.6111C18.375 9.23931 17.3198 8.13194 16.0125 8.13194ZM13.65 17.2222H7.35V13.0903H13.65V17.2222ZM16.0125 11.4375C15.5794 11.4375 15.225 11.0656 15.225 10.6111C15.225 10.1566 15.5794 9.78472 16.0125 9.78472C16.4456 9.78472 16.8 10.1566 16.8 10.6111C16.8 11.0656 16.4456 11.4375 16.0125 11.4375ZM15.225 4H5.775V7.30556H15.225V4Z",
    fill: "#4B5563"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintOn);
export default __webpack_public_path__ + "static/media/PrintOn.c98ccbf81f718693eac0d53d2224f8bf.svg";
export { ForwardRef as ReactComponent };